export interface IHistogeneticsAboUploads{
    Id: number,
    dateUploaded: string,
    vendor: string,
    entityType: number,
    entityTypeId: number,
    entityAboAtUpload: string,
    aboAtUpload: string,
    aliasId: string,
    currentAbo: string,
    discrepancyAtUpload: string
}
